import React from 'react'
import UserProfileService from './../../../shared/services/UserProfile.service'
import LoadingSpinner from './../../shared/LoadingSpinner.component'
import {
  MDBBtn,
  MDBIcon,
  MDBModalHeader,
  MDBModalBody,
  MDBModal,
  MDBSelect,
  MDBModalDialog,
  MDBModalContent,
  MDBModalTitle,
} from 'mdb-react-ui-kit'
import MDB4Datatable from '../../content/MDB4Datatable/MDB4Datatable.component'
import CarrierService from './../../../shared/services/Carrier.service'
import UserCarrierContractService from './../../../shared/services/UserCarrierContractConfiguration.service'
import CarrierContractService from './../../../shared/services/CarrierContract.service'
import { carrierCommisionLevels } from './../../../constants/commisionLevels'

import AdminApi from './../../../api/admin-api/admin-api'

class CarrierCommisionModal extends React.Component {
  state = {
    isLoading: true,
    isOpen: false,
    isEditOpen: false,
    isEditLoading: true,
    isEmpty: false,
    commissionLevels: null,
    carrierConfigExist: false,
    carrierConfigId: null,
    userData: [],
    pagination: { page: 0, per_page: 10 },
    data: {
      columns: [
        {
          label: 'Active Carriers',
          field: 'name',
          sort: 'asc',
          width: '150px',
        },
        {
          label: 'Description',
          field: 'description',
          width: '200px',
        },
        {
          label: 'Select Commisison Level',
          field: 'edit',
          width: '150px',
        },
      ],
      rows: [],
    },
  }

  #toggleCarrierCommisionModal = () => {
    if (!this.state.loading) {
      if (!this.state.isOpen) this.#fetchActiveCarrierInfo()
      this.setState({ isOpen: !this.state.isOpen })
    }
  }

  onCommissionLevelChange = (value, carrierId) => {
    // Here we need to update the commsion overide table
    this.setState(prevState => {
      let userData = Object.assign({}, prevState.userData)
      // Ensure 'commision_id' exists as an object before setting the carrierId
      if (!userData['commision_id']) {
        userData['commision_id'] = {}
      }
      userData['commision_id'][carrierId] = value
      return { userData }
    })
  }

  #fetchActiveCarrierInfo = async () => {
    // console.log("Here", this.state.isOpen)

    this.setState(prevState => {
      let userData = Object.assign({}, prevState.userData)
      // Ensure 'commision_id' exists as an object before setting the carrierId
      userData['commision_id'] = {}
      userData['carrierConfigExist'] = {}
      return { userData }
    })

    const userContractConfig = await UserCarrierContractService.search({
      search: { user_id: UserProfileService.getUserId() },
      pagination: false,
    })

    // console.log(userContractConfig)
    let userCommisionOveride = []
    userCommisionOveride = userContractConfig?.models.map(item => {
      this.setState(prevState => {
        let userData = Object.assign({}, prevState.userData)
        // Ensure 'commision_id' exists as an object before setting the carrierId
        if (!userData['carrierConfigExist']) {
          userData['carrierConfigExist'] = {}
        }

        userData['carrierConfigExist'][item.carrier_id] = item.id
        return { userData }
      })
      return { [item.carrier_id]: item.commision_id }
    })

    // console.log(userCommisionOveride)

    // Load commission levels
    let commissionLevels = []
    try {
      commissionLevels = (await AdminApi.getCommissionLevelList())?.data?.data || []
    } catch (ex) {
      console.error('Error loading commission levels', ex)
    }

    let carrierContract = await CarrierContractService.search({
      pagination: false,
    })

    // Build Table row commision levels
    const buildRow = Carrier => {
      const updatedCommissionLevels = commissionLevels
        .map(item => {
          const matchingCarrier = carrierContract.models.find(model => Carrier.id === model.carrier_id)

          const carrierKey = carrierCommisionLevels[item.com_code]

          if (
            carrierKey &&
            matchingCarrier &&
            carrierCommisionLevels[item.com_code] &&
            matchingCarrier.hasOwnProperty(carrierKey) &&
            matchingCarrier[carrierKey]
          ) {
            let matchingCommission = []
            matchingCommission = userCommisionOveride.find(commisionObj => commisionObj[Carrier.id])
            return {
              text: item.com_name,
              value: `${item.id}`,
              checked: parseInt(item.id) === parseInt(matchingCommission ? matchingCommission[Carrier.id] : ''),
            }
          } else {
            return null
          }
        })
        .filter(item => item !== null)

      let carObj = {
        name: Carrier.c_name,
        description: Carrier.c_description,
        edit: updatedCommissionLevels.length > 0 ? renderDropdown(Carrier.id, updatedCommissionLevels) : '',
      }
      return carObj
    }

    const renderDropdown = (carrierId, commissionLevels) => (
      <MDBSelect
        data={commissionLevels.map(({ checked, ...opt }) => (checked ? { ...opt, defaultSelected: true } : opt))}
        placeholder='Choose Commission Level'
        preventFirstSelection
        onValueChange={option => {
          if (option?.value != null) this.onCommissionLevelChange(option.value, carrierId)
        }}
        label='Commission Level'
      />
    )

    let carriers = await CarrierService.search({
      search: { c_active: 1 },
      pagination: false,
    })

    // console.log("Carrier", carriers)

    // console.log("Carrier", carriers?.models.map(buildRow).filter((c) => c))
    this.setState({
      data: {
        ...this.state.data,
        rows: carriers?.models.map(buildRow).filter(c => c),
      },
    })
    // console.log("Carrier", CarrierMgmtStore.getCarriers(true))

    this.setState(prevState => ({
      ...prevState,
      isLoading: false,
      isEmpty: carriers?.models?.length === 0,
    }))
  }

  #saveCarrierCommission = async () => {
    // console.log(this.state.userData)

    try {
      if (this.state.userData['commision_id']) {
        let userData = this.state.userData
        for (let carrierId in userData.commision_id) {
          if (userData.commision_id.hasOwnProperty(carrierId)) {
            if (
              userData.commision_id[carrierId] !== undefined &&
              userData.carrierConfigExist[carrierId] !== undefined
            ) {
              let commissionData = {
                carrier_id: carrierId,
                commision_id: userData.commision_id[carrierId],
                user_id: UserProfileService.getUserId(),
              }
              UserCarrierContractService.update(userData.carrierConfigExist[carrierId], commissionData)
            } else if (userData.commision_id[carrierId] !== undefined) {
              let commissionData = {
                carrier_id: carrierId,
                commision_id: userData.commision_id[carrierId],
                user_id: UserProfileService.getUserId(),
              }
              UserCarrierContractService.store(commissionData)
            }
          }
        }
      }
    } catch (error) {
      console.error('An error occurred while processing the commission data:', error)
      // Handle the error appropriately, such as setting an error state or notifying the user
    }
  }

  render() {
    return (
      <div id='CarrierCommisionModal'>
        <MDBBtn type='button' className='btn-block mb-1' color='indigo' onClick={this.#toggleCarrierCommisionModal}>
          <MDBIcon icon='user-circle' className='mr-1' /> Contracting Configuration
        </MDBBtn>

        <MDBModal open={this.state.isOpen} tabIndex='-1' onClose={this.#toggleCarrierCommisionModal}>
          <MDBModalDialog size='xl'>
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle>Contracting Configuration</MDBModalTitle>
                <MDBBtn
                  type='button'
                  className='btn-close'
                  color='none'
                  onClick={this.#toggleCarrierCommisionModal}
                ></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody className={this.state.isLoading ? 'is-loading' : ''}>
                {this.state.isLoading ? (
                  <div className='loading-wrapper'>
                    <LoadingSpinner size='md' isActive={true} />
                  </div>
                ) : (
                  <>
                    <div>
                      <MDB4Datatable
                        data={this.state.data}
                        paging={true}
                        striped
                        order={['name', 'asc']}
                        bordered
                        style={{
                          tableLayout: 'fixed', // Ensures fixed column width
                          width: '100%',
                        }}
                      />
                    </div>
                    <MDBBtn
                      type='button'
                      color='indigo'
                      block
                      className='btn btn-info'
                      onClick={() => {
                        // Add Update Commison setting callback
                        // console.log(this.state.userData)

                        this.#saveCarrierCommission()
                        this.#toggleCarrierCommisionModal()
                      }}
                    >
                      Update
                    </MDBBtn>
                    <MDBBtn type='button' color='warning' size={'sm'} block onClick={this.#toggleCarrierCommisionModal}>
                      Close
                    </MDBBtn>
                  </>
                )}
              </MDBModalBody>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>
      </div>
    )
  }
}

export default CarrierCommisionModal
